var fowtr_module_chapter__dev = (function (fowtr_module_chapter__dev) {

    fowtr_module_chapter__dev.init = function(chapter){

      
      console.log('fowtr_module_chapter__dev initialised');

      // set up scrollMagic
      var fowtr_module_chapter_4 = {};
      fowtr_module_chapter_4.controller = new ScrollMagic.Controller();



      // // ------------------------------------------------------------------------------------------------------
      // // article 19 parallax
      // // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter4 #fowtr-article19 .fowtr-parallax-bg').css({
      //   'top':'-41%',
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article19", duration: "200%", triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter4 #fowtr-article19 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_4.controller);









      // PUT SECTION ID MARKERS ON ALL ARTICLES
      $.each($('#fowtr-chapter4 article > div'), function(index, val) {
         var id = $(this).attr('id');
         if(id){
          id = id.replace('fowtr-article','');
          console.log('article',id);
          var marker = $('<div style="background:magenta;color:white;position: absolute;top: 50%;left: 0;transform: rotate(-90deg);transform-origin: top left;padding: 10px;font-weight: bold;">Section '+id+'</div>');
          $('#fowtr-article'+id).append(marker);
         }
      });




    };// end init function



    // fowtr_module_chapter__dev.openMapPopup = function(id){

    // };



    return fowtr_module_chapter__dev;
}(fowtr_module_chapter__dev || {}));

